export default __webpack_public_path__ + "static/baia-do-sancho-33dd562110c81eea3efa90e83b17c3ed.jpg";